import axios, { AxiosRequestConfig } from "axios"
import { hackleClient } from "../hackleClient"

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status) {
      const { status, data, config } = error.response
      hackleClient.track({
        key: "homepage_error",
        properties: {
          errorCode: status,
          errorType: "api",
          errorMessage: data.error,
          apiMethod: config.method,
          apiUrl: config.url,
        },
      })
      return Promise.reject(error)
    }
  }
)

export async function get<T>(url: string, config?: AxiosRequestConfig) {
  return axios.get<T>(url, config)
}

export async function post<T>(url: string, data?: any, config?: AxiosRequestConfig) {
  return axios.post<T>(url, data, config)
}

export async function put<T>(url: string, data?: any, config?: AxiosRequestConfig) {
  return axios.put<T>(url, data, config)
}

export async function patch<T>(url: string, data?: any, config?: AxiosRequestConfig) {
  return axios.patch<T>(url, data, config)
}

export async function del<T>(url: string, config?: AxiosRequestConfig) {
  return axios.delete<T>(url, config)
}

interface SuccessWebResponse<T> {
  data: T
  error: false
}
interface ErrorWebResponse {
  error: true
  message: string
  code: string
}
export type WebResponse<T> = SuccessWebResponse<T> | ErrorWebResponse
